import {
  areAllMembersExpanded as areAllMembersExpandedUtil,
  computeOrgGroupsExpandedState,
  computeExpandOnlineInOrgState,
  computeGroupMembersExpandedState,
  computeExpandOnlineInGroupState
} from './memberTreeHelpers';

/**
 * 队员树：组织/小组「全部展开/收起」「仅展开在线」等操作
 * 自 pages/DashboardAuthenticated.js 原样迁出；每次渲染按当前状态重新生成（与拆分前相同）。
 */
export function createMemberTreeExpandActions({
  openGroup,
  openMember,
  highlightedMemberIds,
  setOpenGroup,
  setOpenMember,
  setHighlightedMemberIds
}) {
  // 组织下：全部展开/收起全部小组（收起时同步收起队员详情）
  const setOrgGroupsExpanded = (groupsMap, expand) => {
    const next = computeOrgGroupsExpandedState(
      { openGroup, openMember, highlightedMemberIds },
      groupsMap,
      expand
    );
    setOpenGroup(next.openGroup);
    if (!expand) {
      setOpenMember(next.openMember);
      setHighlightedMemberIds(next.highlightedMemberIds);
    }
  };

  const expandOnlineInOrg = (groupsMap) => {
    const next = computeExpandOnlineInOrgState(
      { openGroup, openMember, highlightedMemberIds },
      groupsMap
    );
    setOpenGroup(next.openGroup);
    setOpenMember(next.openMember);
    setHighlightedMemberIds(next.highlightedMemberIds);
  };

  const setGroupMembersExpanded = (membersList, expand) => {
    const next = computeGroupMembersExpandedState(
      { openMember, highlightedMemberIds },
      membersList,
      expand
    );
    setOpenMember(next.openMember);
    setHighlightedMemberIds(next.highlightedMemberIds);
  };

  const expandOnlineInGroup = (membersList) => {
    const next = computeExpandOnlineInGroupState(
      { openMember, highlightedMemberIds },
      membersList
    );
    setOpenMember(next.openMember);
    setHighlightedMemberIds(next.highlightedMemberIds);
  };

  const areAllGroupsExpanded = (groupsMap) => {
    const names = Object.keys(groupsMap || {});
    return names.length > 0 && names.every((g) => !!openGroup[g]);
  };

  const areAllMembersExpanded = (membersList) => areAllMembersExpandedUtil(membersList, openMember);

  return {
    setOrgGroupsExpanded,
    expandOnlineInOrg,
    setGroupMembersExpanded,
    expandOnlineInGroup,
    areAllGroupsExpanded,
    areAllMembersExpanded
  };
}
